import { Command } from 'commander'
import { createClient } from '../../client.js'
import { handleError } from '../../lib/errors.js'
import { isQuiet, printQuiet, printJson, printSuccess } from '../../output.js'

export const environmentsUpdateCommand = new Command(`update`)
  .usage(`<id> --name <name>`)
  .description(`Update an environment's name`)
  .argument(`<id>`, `Environment ID`)
  .requiredOption(`--name <name>`, `New environment name`)
  .action(async (environmentId: string, opts) => {
    const json = environmentsUpdateCommand.parent?.parent?.opts().json ?? false
    try {
      const client = createClient()
      const result = await client.environments.update({
        environmentId,
        name: opts.name,
      })

      if (isQuiet()) {
        printQuiet(environmentId)
        return
      }

      if (json) {
        printJson(result)
      } else {
        printSuccess(`Environment ${environmentId} updated.`)
      }
    } catch (error) {
      await handleError(error, json)
    }
  })
